<script setup>
import { ref, onMounted, watch } from 'vue';
import $ from 'jquery';
import  'jquery.marquee';

const props = defineProps({
    texts: {
        type: Array,
        required: true,
        default: [
            { text: "This is marquee test 1 with repeat 1, pauseOnHover: true", repeat: 1, duration: 3000, reverse: false, delayBeforeStart: 0, pauseOnHover: true, style: { color: 'white', backgroundColor: 'red' } },
            { text: "This is marquee test 2 with repeat 2, pauseOnHover: false", repeat: 2, duration: 5000, reverse: false, delayBeforeStart: 500, pauseOnHover: false, style: { color: 'black', backgroundColor: 'yellow' } },
            { text: "This is marquee test 3 with repeat 1 reverse direction, pauseOnHover: true", repeat: 1, duration: 7000, reverse: true, delayBeforeStart: 500, pauseOnHover: true },
        ]
    },
    duration: {
        type: Number,
        default: 15000
    },
    delayBeforeStart: {
        type: Number,
        default: 0
    },
    delayCycleBeforeStart: {
        type: Number,
        default: 0
    },
    pauseOnHover: {
        type: Boolean,
        default: true
    },
    disabled: {
        type: Boolean,
        default: false
    },
    loop: { // If this set to true then it will loop all texts all the time
        type: Boolean,
        default: false
    },
    style: {
        type: Object,
        default: () => ({})
    },
    resetPlayed: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['onStatusChange']);

const style = ref({
    position: 'fixed',
    left: '0',
    width: '100%',
    zIndex: '2147483647',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    cursor: 'default',

    // Don't override the above styles
    // You can override theses styles by passing style prop 
    //top: '0px', // will be set from outside, because there is top and bottom, both cannot be set at same time
    color: 'white',
    backgroundColor: 'black',
    height: '30px',
    fontFamily: "default",
    fontSize: "16px",
    fontWeight: "800",

    ...props.style // for overriding styles..
});
const styleBackup = ref({ ...style.value });

const marquee = ref(null);
let currentRunningPromiseResolve = null;
let currentCyclePromiseResolve = null;

async function runningMarquee(){
    if(props.disabled) {
        stopMarquee();
        return;
    }

    if(props.texts.length == 0 || (!props.loop && props.texts.every(text => text.repeat > 0) && props.texts.every(text => text.played >= text.repeat))){
        stopMarquee();
        return;
    }

    for(let i = 0; i < props.texts.length; i++){
        if(typeof props.texts[i].played == 'undefined'){
            props.texts[i].played = 0;
        }

        if(typeof props.texts[i].repeat == 'undefined'){
            props.texts[i].repeat = 1;
        }

        if(!props.loop && props.texts[i].repeat > 0 && props.texts[i].played >= props.texts[i].repeat){
            continue;
        }

        style.value = { ...styleBackup.value, ...props?.texts[i]?.style };
        if(!style?.value?.top && !style?.value?.bottom) style.value.top = '0px';

        await new Promise((resolve) => {
            currentRunningPromiseResolve = resolve;

            $(marquee.value).text(props.texts[i]?.text).marquee({
                direction: props.texts[i].reverse ? 'right' : 'left', // false is left // e.g. for english // true is right // e.g. for arabic
                duration: props.texts[i].duration ?? props.duration,
                delayBeforeStart: props.texts[i].delayBeforeStart ?? props.delayBeforeStart,
                pauseOnHover: props.texts[i].pauseOnHover ?? props.pauseOnHover,
            })
            .bind('finished', function(){
                $(this).marquee('destroy');
                $(this).text("");

                props.texts[i].played++;

                resolve(true);
            });
        });

        style.value = { ...styleBackup.value };

        if (props.disabled) {
            break;
        }
    }

    await new Promise(resolve => setTimeout(function(){
        currentCyclePromiseResolve = resolve;
        resolve(true);
    }, props.delayCycleBeforeStart));

    runningMarquee();
}

function startMarquee(){
    if(props.resetPlayed) props.texts.forEach(text => text.played = 0);

    emit('onStatusChange', 'started');

    runningMarquee();
}

function stopMarquee(){
    if (currentRunningPromiseResolve) {
        currentRunningPromiseResolve(true);
        currentRunningPromiseResolve = null;
    }

    if (currentCyclePromiseResolve) {
        currentCyclePromiseResolve(true);
        currentCyclePromiseResolve = null;
    }

    $(marquee.value).marquee('destroy');
    $(marquee.value).text("");

    emit('onStatusChange', 'stopped');
}

onMounted(() => {
    if(!props.disabled){
        startMarquee();
    }
});

watch(() => props.disabled, (isDisabled) => {
    if(isDisabled) {
        stopMarquee();
    } 
    else {
        startMarquee();
    }
});
</script>

<style scoped>
    .no-select {
        user-select: none;
        -webkit-user-select: none; /* Safari */
        -moz-user-select: none;    /* Firefox */
        -ms-user-select: none;     /* Internet Explorer/Edge */
    }
</style>

<template>
    <div ref="marquee" :style="style" class="no-select"></div>
</template>
